import type { Language } from "@/i18n/translations";

export type RouteKey = "home" | "insights" | "insightsArticle" | "disclosure" | "threatMap";

export const LANG_PREFIX: Record<Language, string> = {
  pt: "/pt-br",
  en: "/en",
  es: "/es",
};

export const LANG_HTML: Record<Language, string> = {
  pt: "pt-BR",
  en: "en",
  es: "es",
};

export const LOCALE: Record<Language, string> = {
  pt: "pt_BR",
  en: "en_US",
  es: "es_ES",
};

export const DISCLOSURE_SLUG: Record<Language, string> = {
  pt: "divulgacao-responsavel",
  en: "responsible-disclosure",
  es: "divulgacion-responsable",
};

export const THREAT_MAP_SLUG: Record<Language, string> = {
  pt: "mapa-de-ameacas",
  en: "threat-map",
  es: "mapa-de-amenazas",
};

export const localizedPath = (
  key: RouteKey,
  lang: Language,
  slug?: string,
): string => {
  const p = LANG_PREFIX[lang];
  switch (key) {
    case "home":
      return `${p}/`;
    case "insights":
      return `${p}/insights`;
    case "insightsArticle":
      return `${p}/insights/${slug}`;
    case "disclosure":
      return `${p}/${DISCLOSURE_SLUG[lang]}`;
    case "threatMap":
      return `${p}/${THREAT_MAP_SLUG[lang]}`;
  }
};

export const detectLangFromPath = (pathname: string): Language | null => {
  if (pathname === "/pt-br" || pathname.startsWith("/pt-br/")) return "pt";
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (pathname === "/es" || pathname.startsWith("/es/")) return "es";
  return null;
};

// Absolute canonical URL for a given localized path
export const SITE_URL = "https://sentinelhub.com.br";
export const absUrl = (path: string) => `${SITE_URL}${path}`;
